// extracted by mini-css-extract-plugin
export default {"title":"RegistrarMissedAttendance_title__Tpehs"};